import { useTranslation } from 'react-i18next';
import {
    Box,
    InputBase,
    IconButton,
} from '@mui/material';
import {
    Search,
    ClearOutlined,
} from '@mui/icons-material';

function SearchBar({ value, onChange, onClear }) {
    const { t } = useTranslation();

    return (
        <>
            <Box sx={{ backgroundColor: 'whitesmoke', display: 'flex' }}>
                <Search sx={{ color: 'gray', p: 1.5 }} />
                <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder= {t('sucheSearchBar', { ns:'common', defaultValue: "Suche..."  })}
                    value={value}
                    onChange={onChange}
                />
                <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={onClear}>
                    <ClearOutlined />
                </IconButton>
            </Box>
        </>
    );
};

export default SearchBar
